import API from "../api";
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// 🟢 NEW: Haptic Feedback Engine
const vibrate = (pattern) => {
  if (typeof window !== "undefined" && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};

function Login() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!phone || !password) {
      vibrate([100, 50, 100]); // 📳 Error double-vibrate
      alert("All fields required");
      return;
    }

    // 🚨 VALIDATION: Must be exactly 10 digits to even try logging in
    if (phone.length !== 10) {
      vibrate([100, 50, 100]); // 📳 Error double-vibrate
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      const res = await API.post("/auth/login", {
        phone,
        password
      });

      // Save token and user details to local storage
      localStorage.setItem("userToken", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      vibrate([50, 50, 50]); // 📳 Success burst!
      alert("Login successful!");
      navigate("/"); // Redirect to shop page
      
    } catch (err) {
      vibrate([100, 50, 100]); // 📳 Error double-vibrate on backend rejection
      alert(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <div style={pageContainer}>
      <div style={authCard}>
        
        <div style={iconCircle}>👤</div>
        <h2 style={titleStyle}>Welcome Back</h2>
        <p style={subtitleStyle}>Log in to access your cart and orders.</p>

        <form onSubmit={handleLogin}>
          <label style={labelStyle}>Phone Number</label>
          <input
            type="tel"
            placeholder="10-digit mobile number"
            value={phone}
            maxLength="10" // Stop typing after 10 chars
            // 🚨 AUTO-FORMAT: Remove non-numbers instantly
            onChange={e => setPhone(e.target.value.replace(/\D/g, ""))}
            style={inputStyle}
          />

          <label style={labelStyle}>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={inputStyle}
          />

          {/* Forgot Password Link */}
          <div style={forgotPasswordContainer}>
            <span 
              style={forgotLinkStyle} 
              onClick={() => {
                vibrate(20); // 📳 Micro tap
                navigate("/forgot-password");
              }}
            >
              Forgot Password?
            </span>
          </div>

          <button type="submit" style={submitBtn}>
            Login Securely
          </button>
        </form>

        {/* Signup Link */}
        <div style={footerText}>
          New to Delight Store? <Link to="/signup" onClick={() => vibrate(20)} style={linkStyle}>Create an account</Link>
        </div>

      </div>
    </div>
  );
}

// ================= THEMATIC STYLES =================
const pageContainer = { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "85vh", padding: "20px", background: "#FAFAFA", fontFamily: "'Segoe UI', Roboto, sans-serif" };
const authCard = { background: "#FFF", width: "100%", maxWidth: "400px", padding: "40px 30px", borderRadius: "16px", boxShadow: "0 10px 30px rgba(0,0,0,0.06)", border: "1px solid #E0E0E0" };
const iconCircle = { width: "60px", height: "60px", background: "#FFF3E0", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto 15px auto", fontSize: "28px" };
const titleStyle = { color: "#333", fontSize: "26px", textAlign: "center", margin: "0 0 5px 0" };
const subtitleStyle = { color: "#666", fontSize: "14px", textAlign: "center", marginBottom: "25px" };
const labelStyle = { display: "block", fontSize: "13px", fontWeight: "600", color: "#555", marginBottom: "6px", marginTop: "15px" };
const inputStyle = { width: "100%", padding: "12px 15px", borderRadius: "8px", border: "1px solid #CCC", background: "#FAFAFA", outline: "none", boxSizing: "border-box", fontSize: "15px", transition: "0.3s" };
const submitBtn = { width: "100%", padding: "14px", marginTop: "25px", background: "#F57C00", color: "#FFF", border: "none", borderRadius: "8px", fontSize: "16px", fontWeight: "bold", cursor: "pointer", boxShadow: "0 4px 12px rgba(245, 124, 0, 0.25)" };
const forgotPasswordContainer = { textAlign: "right", marginTop: "10px" };
const forgotLinkStyle = { color: "#E65100", fontSize: "13px", fontWeight: "600", cursor: "pointer", textDecoration: "none" };
const footerText = { textAlign: "center", marginTop: "25px", fontSize: "14px", color: "#666", borderTop: "1px solid #eee", paddingTop: "20px" };
const linkStyle = { color: "#2E7D32", fontWeight: "bold", textDecoration: "none" };

export default Login;